import * as React from 'react';
import isString from 'lodash/isString';

import InsightsReportsReportPage from './InsightsReportsReportPage';

import { COLLABARY, INSTAGRAM } from 'modules/insights/reports/utils/insights-reports';

import type { LocationWindow } from 'types';
import type { GeneralProps } from 'modules/insights/reports/types';

type Props = {
  params: GeneralProps,
  location: LocationWindow
};

const InsightsReportsReportPageBase: React.FunctionComponent<Props> = ({
  params,
  location
}: Props) => {
  const path = isString(location.path) ? location.path : '';
  const reportType = params.reportType || INSTAGRAM;
  const collabary = path.includes('/insights/') && COLLABARY;

  if (!collabary) {
    return null;
  }

  return (
    <InsightsReportsReportPage
      params={params}
      location={location}
      reportType={reportType}
    />
  );
};

export default InsightsReportsReportPageBase;
